import { Directive, ElementRef, HostBinding } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

//services
import { SharedService } from "../../services/shared.service";
import { AppState } from "../../redux/store";
import { PrimeNG } from "primeng/config";
import { Store } from "@ngrx/store";
import {
  REQUEST_DASHBOARD_REFRESH,
  UI__REQUEST_SET_LANG,
  UI__SET_LANG,
} from "../../ngrx/ngrx-actions";
import { Subject } from "rxjs";
import { ofType, Actions } from "@ngrx/effects";
import { map, take, takeUntil } from "rxjs/operators";

@Directive({
  selector: "[translate]",
  standalone: true,
})
export class TranslateDirective {
  lang: string = "";
  defaultLang: string = "he";
  @HostBinding("class.is-rtl") get valid() {
    return this.isRtl();
  }
  @HostBinding("class.is-ltr") get invalid() {
    return !this.isRtl();
  }

  destroy$ = new Subject();

  constructor(
    private sharedService: SharedService,
    private translate: TranslateService,
    private el: ElementRef,
    private activatedRoute: ActivatedRoute,
    private readonly store: Store,
    private primeNG: PrimeNG,
    private actions$: Actions
  ) { }

  ngOnInit() {
    // set lang by parameter
    this.activatedRoute.data.subscribe((data) => {
      if (data.lang) {
        this.lang = data.lang;
        this.setLang();
      }
    });

    this.actions$
      .pipe(
        ofType(UI__REQUEST_SET_LANG),
        //takeUntil(this.destroy$),
        map(({ lang }) => {
          this.lang = lang;
          this.setLang(true);
        })
      )
      .subscribe();

    this.setLang();
  }

  ngOnDestroy(): void {
    this.destroy$.next(1);
  }

  setLang(saveCookie: boolean = false) {
    let _lang: string = saveCookie
      ? this.lang || this.sharedService.getCookie("lang") || this.defaultLang
      : this.sharedService.getCookie("lang") || this.defaultLang || this.lang;

    let _direction: string;

    if (this.sharedService.overwriteUserLang)
      _lang = this.sharedService.overwriteUserLang;

    _lang = _lang.toLowerCase();

    if (!_lang) return;

    if (saveCookie) this.sharedService.putCookie("lang", _lang);

    this.translate.use(_lang);
    this.translate
      .get("primeng")
      .subscribe((res) => this.primeNG.setTranslation(res));

    if (this.isRtl(_lang)) {
      document.body.classList.remove("is-ltr");
      document.body.classList.add("is-rtl");
      _direction = "rtl";
    } else {
      document.body.classList.remove("is-rtl");
      document.body.classList.add("is-ltr");
      _direction = "ltr";
    }

    this.el.nativeElement.setAttribute("lang", _lang);
    document.querySelector("html").setAttribute("lang", _lang);

    this.store.dispatch(
      UI__SET_LANG({
        direction: _direction,
        lang: _lang,
      })
    );

    this.store.dispatch(REQUEST_DASHBOARD_REFRESH());
  }

  isRtl(lang?): boolean {
    const _lang = lang || SharedService.ui_lang;
    if (!_lang) return false;
    // Arabic and Hebrew have ltr direction.
    return _lang.toLowerCase() === "ar" || _lang.toLowerCase() === "he";
  }
}
